import React, { forwardRef } from "react";
import RadioCheck, { RadioCheckProps } from "./RadioCheck";

interface Props extends Omit<RadioCheckProps, "type" | "inContext"> {}

const Checkbox = forwardRef(
    (props: Props, ref: React.ForwardedRef<HTMLInputElement>) => {
        return <RadioCheck {...props} ref={ref} type="checkbox" />;
    },
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
